import { lazy } from 'react'
import { Redirect } from 'react-router-dom'

// ** Document title
const TemplateTitle = '%s - Wiply'

// ** Default Route
const DefaultRoute = '/home'

// ** Merge Routes
const Routes = [
  {
    path: "/home",
    component: lazy(() => import("../../views/Home")),
    // layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
    navbar: {
      // type: 'floating', // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
  },
  // {
  //   path: "/media",
  //   component: lazy(() => import("../../views/Media")),
  // },
  {
    path: "/about",
    component: lazy(() => import("../../views/About")),
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/platform",
    component: lazy(() => import("../../views/Platform")),
    // layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/pricing",
    component: lazy(() => import("../../views/Pricing")),
    // layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
    navbarColor: "blue",
  },

  {
    path: "/demo",
    exact: true,
    component:  lazy(() => import("../../views/demo")),
    navbar: null
  },

  // {
  //   path: "/login",
  //   component: lazy(() => import("../../views/Login")),
  //   layout: "BlankLayout",
  //   meta: {
  //     authRoute: true,
  //   },
  // },
  {
    path: "/login",
    exact: true,
    component: () => (window.location = "https://platform.wiply.co/login"),
  },
  {
    path: "/register-tmp",
    component: lazy(() => import("../../views/RegisterTmp")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  // {
  //   path: "/register",
  //   component: lazy(() => import("../../views/Register")),
  //   layout: "BlankLayout",
  //   meta: {
  //     authRoute: true,
  //   },
  // },
  {
    path: "/register",
    component: () => (window.location = "https://platform.wiply.co/signup"),
  },
  {
    path: "/forgot-password",
    component: lazy(() => import("../../views/ForgotPassword")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/privacy-policy",
    component: lazy(() => import("../../views/PrivacyPolicy")),

    meta: {
      authRoute: true,
    },
  },
  {
    path: "/refund-policy",
    component: lazy(() => import("../../views/RefundPolicy")),

    meta: {
      authRoute: true,
    },
  },
  {
    path: "/delivery-policy",
    component: lazy(() => import("../../views/DeliveryPolicy")),

    meta: {
      authRoute: true,
    },
  },
  {
    path: "/terms-conditions",
    component: lazy(() => import("../../views/TermsConditions")),

    meta: {
      authRoute: true,
    },
  },
  {
    path: "/articles",
    component: lazy(() => import("../../views/articles/Articles")),
    // layout: 'BlankLayout',
    meta: {
      contentWidth: 'boxed'
    }
  },
  {
    path: '/article/detail/:id',
    exact: true,
    component: lazy(() => import('../../views/articles/details')),
    meta: {
      contentWidth: 'boxed'
    }
    // meta: {
    //   navLink: '/articles/detail'
    // }
  },
  {
    path: '/article/detail',
    exact: true,
    component: () => <Redirect to='/article/detail/1' />
  },
  {
    path: "/error",
    component: lazy(() => import("../../views/Error")),
    layout: "BlankLayout",
  },
];

export { DefaultRoute, TemplateTitle, Routes }
